export default "__VITE_ASSET__feb6b346__"